import { getYearMonth } from './time';

export const toWebpPath = (src?: string | null): string => {
  if (!src) return '';
  if (src.startsWith('data:')) return src;
  if (src.toLowerCase().endsWith('.webp')) return src;
  return src.replace(/\.(png|jpe?g)(\?.*)?$/i, '.webp$2');
};

export const imageDetailUrl = (image: { id: number; hash: string; time?: number | string; year?: string; month?: string }): string => {
  const params = new URLSearchParams({ page: 'gallery', view: 'image', id: String(image.id), hash: image.hash });
  const date = image.year && image.month ? { year: image.year, month: image.month } : getYearMonth(image.time);
  if (date) { params.set('year', date.year); params.set('month', date.month); }
  return `/?${params}`;
};
